import { authFetch } from 'src/auth/utils';
import { envVariables } from 'src/common/utils/envVariables';
import { ESimProfilesDTO } from '../models/eSimProfiles';

type FetchESimProfilesArgs = {
  eid: string;
};

export const fetchESimProfiles = async ({ eid }: FetchESimProfilesArgs, signal?: AbortSignal) => {
  const esimProfilesResponse = await authFetch(
    `${envVariables.VITE_ESIMS_INGESTION_API}/e-sim/${eid}/profiles`,
    {
      signal,
    },
  );

  const profiles: ESimProfilesDTO = await esimProfilesResponse.json();

  return {
    items: profiles.profilesInfo.map((profile) => ({ ...profile, esimEid: eid })),
  };
};
